export default function ScrollImage() {
  const blocks = document.querySelectorAll<HTMLDivElement>(".js-scroll-image-block");

  blocks.forEach((block) => {
    const contentItems = Array.from(block.querySelectorAll<HTMLDivElement>(".js-content-item"));
    const imageItems = Array.from(block.querySelectorAll<HTMLDivElement>(".js-image-item"));
    const stickyWrapper = block.querySelector<HTMLDivElement>(".js-sticky-wrapper");

    let offset = 0;
    let activeIndex = -1;

    const getWindowCenter = () => Math.ceil(window.innerHeight / 2);

    const handleStickyTop = () => {
      if (stickyWrapper) {
        offset = getWindowCenter() - Math.ceil(stickyWrapper.offsetHeight / 2);
        stickyWrapper.style.top = `${offset}px`;
      }
    };

    const setActiveImage = (index: number) => {
      if (index === activeIndex) return;

      imageItems.forEach((img, i) => {
        img.dataset.active = i === index ? "true" : "false";
      });

      activeIndex = index;
    };

    const handleScroll = () => {
      let closestIndex = 0;
      let closestOffset = -Infinity;

      contentItems.forEach((item) => {
        const index = Number(item.dataset.index);
        const offset = item.getBoundingClientRect().top;

        if (offset < getWindowCenter() && offset > closestOffset) {
          closestOffset = offset;
          closestIndex = index;
        }
      });

      setActiveImage(closestIndex);
    };

    // init on page load
    handleStickyTop();
    handleScroll();
    // listeners
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleStickyTop);
  });
}
